// extracted by mini-css-extract-plugin
export default {"DropdownMenu":"DropdownMenu---Loya0"};